import React from "react";

const ConfirmationOrder = ({ order }) => {
  // order vendría como prop o desde contexto/estado global
  // Ejemplo: { id: "123456789", products: ["Camisa Casual", "Jeans Denim"], total: 79.98 }

  return (
    <div
      className="flex items-center justify-center min-h-screen bg-white"
      style={{ fontFamily: '"Plus Jakarta Sans", "Noto Sans", sans-serif' }}
    >
      <div className="w-full max-w-[512px] p-6 md:p-10 bg-white shadow-md rounded-lg">
        <h2 className="text-[#141414] text-[28px] font-bold text-center pb-3 pt-5">
          ¡Pedido Confirmado!
        </h2>
        <p className="text-[#141414] text-base text-center pb-3">
          Su pedido ha sido realizado y pagado en su totalidad.
          ¡Gracias por comprar con nosotros!
        </p>

        <h3 className="text-[#141414] text-lg font-bold px-4 pb-2 pt-4 text-center">
          Detalles del Pedido
        </h3>

        <div className="p-4 grid grid-cols-[30%_1fr] gap-x-6">
          <div className="col-span-2 grid grid-cols-subgrid border-t border-t-[#e0e0e0] py-4">
            <p className="text-[#757575] text-sm">ID del Pedido</p>
            <p className="text-[#141414] text-sm font-medium">
              #{order?.id || "123456789"}
            </p>
          </div>

          <div className="col-span-2 grid grid-cols-subgrid border-t border-t-[#e0e0e0] py-4">
            <p className="text-[#757575] text-sm">Productos</p>
            <p className="text-[#141414] text-sm font-medium">
              {order?.products?.join(", ") || "Camisa Casual, Jeans Denim"}
            </p>
          </div>

          <div className="col-span-2 grid grid-cols-subgrid border-t border-t-[#e0e0e0] py-4">
            <p className="text-[#757575] text-sm">Monto Total</p>
            <p className="text-[#141414] text-sm font-medium">
              ${order?.total?.toFixed(2) || "79.98"}
            </p>
          </div>
        </div>

        <div className="flex px-4 py-3 justify-center">
          <button
            className="flex items-center justify-center rounded-lg h-10 px-4 bg-[#666666] text-white text-sm font-bold"
            onClick={() => (window.location.href = "/mis-compras")}
          >
            Ver Historial de Pedidos
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationOrder;
